/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ViewSettings } from './ViewSettings';
import { ViewSettingsFromJSON, ViewSettingsFromJSONTyped, ViewSettingsToJSON } from './ViewSettings';

/**
 *
 * @export
 * @interface PaginatedViewSettingsList
 */
export interface PaginatedViewSettingsList {
  /**
   *
   * @type {number}
   * @memberof PaginatedViewSettingsList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedViewSettingsList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedViewSettingsList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<ViewSettings>}
   * @memberof PaginatedViewSettingsList
   */
  results: Array<ViewSettings>;
}

/**
 * Check if a given object implements the PaginatedViewSettingsList interface.
 */
export function instanceOfPaginatedViewSettingsList(value: object): value is PaginatedViewSettingsList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedViewSettingsListFromJSON(json: any): PaginatedViewSettingsList {
  return PaginatedViewSettingsListFromJSONTyped(json, false);
}

export function PaginatedViewSettingsListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedViewSettingsList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(ViewSettingsFromJSON),
  };
}

export function PaginatedViewSettingsListToJSON(value?: PaginatedViewSettingsList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(ViewSettingsToJSON),
  };
}
